import { permissionAssignments } from '../generated/permission-assignments';

import type { Permission } from '../generated/types';
import type { AnyRole } from './role-typeguards';

export function getPermissionAssignments(
    role: AnyRole
): ReadonlySet<Permission> {
    return permissionAssignments[role] ?? new Set();
}
